import { Typography } from 'antd';
import React from 'react';
import './custom-label.scss';

export const CustomLabel = ({ text }: { text: string }) => {
  return <Typography className="custom-label">{text}</Typography>;
};
